import React from 'react';
import '../style/card.scss'; // Import the new SCSS file
interface CardProps {
  title: string;
  desc: string;
  imageUrl: string;
}

const Card: React.FC<CardProps> = ({ title, desc, imageUrl }) => {
  return (
    <div className="card">
      <div
        className="card__img"
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div>
      <div className="card__text">
        <div className="card__text-title h5">{title}</div>
        <div className="card__text-desc body-m">{desc}</div>
      </div>
    </div>
  );
};

export default Card;
